import React from "react";
import { Link } from "react-router-dom";
import { Truck } from "lucide-react";

export default function Footer() {
  const toTop = () => window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  return (
    <footer className="border-t border-[#1F4032]/10 mt-16 bg-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-4 gap-8">
        <div>
          <Link to="/" onClick={toTop} className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#1F4032] flex items-center justify-center">
              <Truck className="w-4 h-4 text-white" strokeWidth={2.5} />
            </div>
            <span className="font-display font-bold text-xl tracking-tighter">MML</span>
          </Link>
          <p className="text-sm text-muted-foreground mt-3 max-w-xs">
            La marketplace logistique française qui connecte expéditeurs et transporteurs vérifiés.
          </p>
        </div>

        <div>
          <div className="overline mb-3">Plateforme</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" onClick={toTop} className="hover:text-[#1F4032]">Accueil</Link></li>
            <li><Link to="/register" onClick={toTop} className="hover:text-[#1F4032]">S'inscrire</Link></li>
            <li><Link to="/login" onClick={toTop} className="hover:text-[#1F4032]">Connexion</Link></li>
            <li><Link to="/contact" onClick={toTop} className="hover:text-[#1F4032]" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-3">Légal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/mentions" onClick={toTop} className="hover:text-[#1F4032]" data-testid="footer-mentions-link">Mentions légales</Link></li>
            <li><Link to="/legal/terms" onClick={toTop} className="hover:text-[#1F4032]" data-testid="footer-terms-link">CGU</Link></li>
            <li><Link to="/legal/contrat-transport" onClick={toTop} className="hover:text-[#1F4032]" data-testid="footer-contrat-link">Contrat de transport</Link></li>
            <li><Link to="/legal/intermediation" onClick={toTop} className="hover:text-[#1F4032]" data-testid="footer-intermediation-link">Clauses d'intermédiation</Link></li>
            <li><Link to="/legal/privacy" onClick={toTop} className="hover:text-[#1F4032]" data-testid="footer-privacy-link">Politique de confidentialité</Link></li>
            <li><Link to="/account/privacy" onClick={toTop} className="hover:text-[#1F4032]" data-testid="footer-rgpd-link">Mes données (RGPD)</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-3">Contact</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" onClick={toTop} className="hover:text-[#1F4032]">Nous contacter</Link></li>
            <li><Link to="/contact" onClick={toTop} className="hover:text-[#1F4032]">Formulaire de contact</Link></li>
            <li className="text-muted-foreground">Lun.–ven. · 9h30–19h30</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1F4032]/10 py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} MML — Plateforme Logistique · Tous droits réservés
      </div>
    </footer>
  );
}
